import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {
    PageLoaderComponent, TermsContentComponent, TabComponent, TabsComponent,
    StepIndicatorComponent, DropdownComponent,
    AccordionListComponent, DatePickerComponent, AccordionComponent,
    MobilePivotComponent, TimeOutPopUpComponent, GvpVideoComponent, BreadcrumbComponent
} from '../ui-components/';

import {
    ComponentPermissionDirective, FieldPermissionDirective, OnlyNumberDirective,
    CtnMaskDirective, ImpersonatorPermissionDirective
} from '../directives/';
import { CMSDirective } from '../directives/cms.directive';
import { ChipsComponent } from '../ui-components/chips/chips.component';

// To Do: dynamic loader, alert-banner

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [
        PageLoaderComponent,
        BreadcrumbComponent,
        TermsContentComponent,
        TabComponent,
        TabsComponent,
        TimeOutPopUpComponent,
        StepIndicatorComponent,
        DropdownComponent,
        AccordionListComponent,
        DatePickerComponent,
        AccordionComponent,
        MobilePivotComponent,
        GvpVideoComponent,
        ComponentPermissionDirective,
        FieldPermissionDirective,
        OnlyNumberDirective,
        CtnMaskDirective,
        ImpersonatorPermissionDirective,
        CMSDirective
    ],
    exports: [
        PageLoaderComponent,
        BreadcrumbComponent,
        TermsContentComponent,
        TabComponent,
        TabsComponent,
        TimeOutPopUpComponent,
        StepIndicatorComponent,
        DropdownComponent,
        AccordionListComponent,
        DatePickerComponent,
        AccordionComponent,
        MobilePivotComponent,
        GvpVideoComponent,
        ComponentPermissionDirective,
        FieldPermissionDirective,
        OnlyNumberDirective,
        CtnMaskDirective,
        ImpersonatorPermissionDirective,
        CMSDirective
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class CoreLibModule { }
